import { PlotCreator } from "../core/view-object-creators/plot-creator";
import { OnlineDataPlot } from "../../../../web-visualizator";

export class OnlinePlotCreator extends PlotCreator {
  constructor(commonSettings) {
    super(commonSettings);
  }

  createPlotObject(settings) {
    return new OnlineDataPlot(settings);
  }
}
